import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '../../css';
import {
  Backdrop,
  Content,
  Button,
  Heading,
  FixedContent,
  ChildrenContent
} from './css';

const ModalCustom = ({ open, setOpen, header, children, customStyles }) => {
  return (
    open && (
      <Backdrop>
        <Content customStyles={customStyles}>
          <FixedContent>
            <Box width={50}>
              <Heading>{header}</Heading>
            </Box>
            <Box
              width={50}
              display="flex"
              justifyContent="flex-end"
              flexDirection="row"
            >
              <Button popupHeader onClick={() => setOpen(null)}>
                {localStorage.getItem('locale') === 'FR'
                  ? 'Fermer X'
                  : 'Close X'}
              </Button>
            </Box>
          </FixedContent>
          <ChildrenContent>{children}</ChildrenContent>
        </Content>
      </Backdrop>
    )
  );
};

ModalCustom.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  customStyles: PropTypes.string
};

ModalCustom.defaultProps = {
  open: false,
  customStyles: null
};
export default ModalCustom;
